import * as React from "react";
import { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import { Button, Col, Modal, Row } from "components/bootstrap";
import FormikInput from "components/common/FormikInput";
import { InputDescription, ModalSubmit, IfPermitted } from "components/common";
import { ConfigurationsActions, ConfigurationsStore } from "stores/configurations/ConfigurationsStore";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import ConfigurationType from "components/configurations/ConfigurationTypes";
import getConfig from "components/configurations/helpers";
import { useStore } from "stores/connect";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import reloadPage from "preflight/components/reloadPage";
import Spinner from "../common/Spinner";
const StyledDefList = styled.dl.attrs({ className: "deflist" })(
  ({ theme }) => css`
    /* stylelint-disable-next-line nesting-selector-no-missing-scoping-root */
    &&.deflist {
      dd {
        padding-left: ${theme.spacings.md};
        margin-left: 400px;
      }
    }
  `
);
const LabelSpan = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
    font-weight: bold;
  `
);
const configType = ConfigurationType.MARKDOWN_CONFIG;
const MarkdownConfig = () => {
  const { t } = useTranslation("configurations");
  const [showModal, setShowModal] = useState(false);
  const [viewConfig, setViewConfig] = useState(void 0);
  const [formConfig, setFormConfig] = useState(void 0);
  const configuration = useStore(ConfigurationsStore, (state) => state == null ? void 0 : state.configuration);
  const sendTelemetry = useSendTelemetry("markdown");
  useEffect(() => {
    ConfigurationsActions.list(configType).then(() => {
      var _a;
      const config = (_a = getConfig(configType, configuration)) != null ? _a : {};
      setViewConfig(config);
      setFormConfig(config);
    });
  }, [configuration]);
  const saveConfig = (values) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.CONFIGURATIONS.USER_UPDATED, {
      app_action_value: "configuration-save"
    });
    ConfigurationsActions.update(configType, values).then(() => {
      if (values.allow_all_image_sources !== viewConfig.allow_all_image_sources || values.allowed_image_sources !== viewConfig.allowed_image_sources) {
        reloadPage();
      } else {
        setShowModal(false);
      }
    });
  };
  const resetConfig = () => {
    setShowModal(false);
    setFormConfig(viewConfig);
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h2", null, t("markdown.title")), /* @__PURE__ */ React.createElement("p", null, t("markdown.description")), !viewConfig ? /* @__PURE__ */ React.createElement(Spinner, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledDefList, null, /* @__PURE__ */ React.createElement("dt", null, t("markdown.allow_all_sources"), ":"), /* @__PURE__ */ React.createElement("dd", null, viewConfig.allow_all_image_sources ? t("markdown.enabled") : t("markdown.disabled")), /* @__PURE__ */ React.createElement("dt", null, t("markdown.allowed_sources_view"), ":"), /* @__PURE__ */ React.createElement("dd", null, viewConfig.allowed_image_sources || "-")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "clusterconfigentry:edit" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize: "xs",
      bsStyle: "info",
      onClick: () => {
        setShowModal(true);
      }
    },
    t("shared.edit_configuration")
  ))), /* @__PURE__ */ React.createElement(Modal, { show: showModal && !!formConfig, onHide: resetConfig }, /* @__PURE__ */ React.createElement(Formik, { onSubmit: saveConfig, initialValues: formConfig }, ({ isSubmitting, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, t("markdown.update_title"))), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "checkbox",
      name: "allow_all_image_sources",
      id: "allow_all_image_sources",
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, t("markdown.allow_all_sources"))
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { help: t("markdown.allow_all_sources_help") })), /* @__PURE__ */ React.createElement(Col, { sm: 12 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "text",
      name: "allowed_image_sources",
      id: "allowed_image_sources",
      disabled: values.allow_all_image_sources === true,
      label: /* @__PURE__ */ React.createElement(LabelSpan, null, t("markdown.allowed_sources"))
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { help: t("markdown.allowed_sources_help") }))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      onCancel: resetConfig,
      isSubmitting,
      isAsyncSubmit: true,
      submitLoadingText: t("shared.update_configuration"),
      submitButtonText: t("shared.update_configuration")
    }
  )))))));
};
export default MarkdownConfig;
